import { SelectInput } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { Station } from '@app/core/types/stations';

export const StationsInput = ({
  stations,
  multiple,
  value,
  onChange,
}: {
  stations: readonly Station[];
  multiple?: boolean;
  value: Station;
  onChange: (value: Station) => void;
}) => {
  const { $t } = useIntl();

  return (
    <SelectInput
      value={value}
      onChange={(value) => {
        onChange(value as Station);
      }}
      label={$t({
        id: 'common.station',
        defaultMessage: 'Emisora',
      })}
      options={stations}
      multiple={multiple}
      getOptionValue={(station) => station.id}
      getOptionLabel={(station) => station.name}
    />
  );
};
